import styled from 'styled-components';
import { media } from 'utils';

const ButtonCircle = styled.button`
  width: 48px;
  height: 48px;
  background-size: 20px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 50%;
  outline: none;

  ${media.tablet`
    width: 38px ;
    height: 38px ;
    background-size: 18px ;
  `}

  ${media.mobileL`
    width: 32px ;
    height: 32px ;
    background-size: 13px;
  `} 
  
  @media (max-width: 320px) {
    width: 28px;
    height: 28px;
    background-size: 12px;
  }
`;

export default ButtonCircle;
